import { Box, CardContent } from '@mui/material';
import bankPlaceHolder from 'assets/overviewSection/bankOfAmerica.png';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import Container from '@mui/material/Container';
import { useEffect, useState } from 'react';
import { Banks } from 'lib/api';

async function bankAuthHandle(data) {
    const bankAuh = await Banks.bankAuth(data);
    if (bankAuh.type === 'Bank/MFARequired') {
        const bankResolveMFAuth = await Banks.bankResolveMFA({
            answer: 'test_answer'
        });
        const { nodes } = bankResolveMFAuth; //return nodes
        if (nodes !== []) {
            return nodes;
        } else return { message: 'nodes not found', ok: false };
    } else {
        return bankAuh;
    }
}

export const ConfirmNewPayment = ({ setCounter, reduceCounter, propertiesBanks, onChangeInput, nodesBankInfo }) => {
    const [secureLogin, setSecureLogin] = useState(false);

    useEffect(() => {
        if (secureLogin) {
            const bankNodes = async () => {
                const value = await bankAuthHandle(propertiesBanks);

                if (value.message) {
                    return alert('Unexpected error');
                }
                nodesBankInfo(value);
                setCounter();
            };
            bankNodes();
            setSecureLogin(false);
        }
    }, [secureLogin]);
    return (
        <Box
            style={{
                width: '455px',
                height: '549px'
            }}>
            <Card
                sx={{
                    background: 'linear-gradient(311deg, rgba(192,1,9,1) 0%, rgba(238,1,11,1) 50%, rgba(240,25,36,1) 100%);'
                }}>
                <CardContent>
                    <Container>
                        <Stack marginTop="1.5rem" alignItems="center">
                            <img src={bankPlaceHolder} width="60%" alt="Bank of america" />
                        </Stack>
                        <Box
                            marginTop="2rem"
                            sx={{
                                backgroundColor: '#ececec',
                                paddingX: '5rem',
                                paddingY: '1.5rem',
                                borderRadius: '1.5rem'
                            }}>
                            <Stack direction="row" justifyContent="center" alignItems="center">
                                <Stack>
                                    <FormControl sx={{ m: 1, minWidth: '100%', height: '30px' }}>
                                        <Typography>Username</Typography>
                                        <TextField
                                            inputProps={{
                                                style: {
                                                    padding: '.5rem'
                                                }
                                            }}
                                            name="identifier"
                                            id="outlined-basic"
                                            variant="outlined"
                                            size="small"
                                            value={propertiesBanks.identifier}
                                            onChange={event => onChangeInput(event.target.name, event.target.value)}
                                        />
                                    </FormControl>
                                    <FormControl
                                        sx={{
                                            m: 1,
                                            minWidth: '100%',
                                            height: '30px',
                                            marginTop: '30PX'
                                        }}>
                                        <Typography>Password</Typography>
                                        <TextField
                                            inputProps={{
                                                style: {
                                                    padding: '.5rem'
                                                }
                                            }}
                                            id="outlined-basic"
                                            variant="outlined"
                                            size="small"
                                            name="password"
                                            value={propertiesBanks.password}
                                            type="password"
                                            onChange={event => onChangeInput(event.target.name, event.target.value)}
                                        />
                                    </FormControl>
                                </Stack>
                            </Stack>
                            <Stack alignItems="center">
                                <Stack marginY={8} direction="row" spacing={1}>
                                    <Button
                                        size="small"
                                        color="inherit"
                                        onClick={() => reduceCounter()}
                                        variant="contained"
                                        sx={{ marginRight: '.5rem' }}>
                                        <ArrowBackIosNewIcon></ArrowBackIosNewIcon>
                                    </Button>
                                    <Button size="small" color="inherit" onClick={() => setSecureLogin(true)} variant="contained">
                                        Secure Login
                                    </Button>
                                </Stack>
                            </Stack>
                        </Box>
                    </Container>
                </CardContent>
            </Card>
        </Box>
    );
};
